import React from 'react';

export const UserManagerContext = React.createContext(undefined);
